import { render } from "./ProductVersionChart.vue?vue&type=template&id=5f9ab254&ts=true"
import script from "./ProductVersionChart.vue?vue&type=script&lang=ts"
export * from "./ProductVersionChart.vue?vue&type=script&lang=ts"

import "./ProductVersionChart.vue?vue&type=style&index=0&id=5f9ab254&lang=less"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__